import React from 'react'
import { BASE_URL } from '../constants/urlConstants'
import { useSelector } from 'react-redux'
import Loader from './Loader'
import Message from './Message'
import PersianText from './PersianText'
function Footer() {
 
  const listLogoImage = useSelector(state => state.listLogoImage)
  const { error, loading, logoImage } = listLogoImage
  return (
    <footer className="rednegin text-white  pt-4">

{loading ? <Loader />
        : error ? <Message variant='danger' text={error} />
     : <div className="container">
        <div className="row">
          {/* ستون اول */}
          <div className="col-md-3">
            <img
              src={`${BASE_URL}/${logoImage.logoFooterImage}`}
              alt="تصویر لوگو"
              style={{
                maxWidth: "90%", // تصویر حداکثر به اندازه والدش باشد
                height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
              }}
            />
            
          </div>
          {/* ستون دوم */}
          <div className="col-md-5">

          
            <a
              referrerpolicy='origin'
              target='_blank'
              href='https://trustseal.enamad.ir/?id=569076&Code=mbdFtHQnPK4hMxJ2wBT8nrYCYTCC77HH'
              style={{ display: "inline-block", color: "blue", textDecoration: "none" }}>
              <img
                referrerpolicy='origin'
                src='https://trustseal.enamad.ir/logo.aspx?id=569076&Code=mbdFtHQnPK4hMxJ2wBT8nrYCYTCC77HH'
                alt=''
                style={{
                  cursor: "pointer",
                  maxWidth: "90%", // تصویر حداکثر به اندازه والدش باشد
                  height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
                }}
                data-code='mbdFtHQnPK4hMxJ2wBT8nrYCYTCC77HH' />
            </a>

            <img
              src={`${BASE_URL}/${logoImage.zarinpalImage}`}
              alt="لوگو"
              style={{
                maxWidth: "30%", // تصویر حداکثر به اندازه والدش باشد
                height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
              }}
            />
            <img
              src={`${BASE_URL}/${logoImage.pasargadImage}`}
              alt="لوگو"
              style={{
                maxWidth: "30%", // تصویر حداکثر به اندازه والدش باشد
                height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
              }}
            />
           
          </div>
          {/* ستون سوم */}
          <div className="col-md-4">
            <p className="text-uppercase large yellownegin">تماس با ما</p>
            <hr />
            <ul className="list-unstyled">
              <li className='footerStyle'><PersianText>{logoImage.address}</PersianText></li>
              <li className='footerStyle'><PersianText>{logoImage.phoneNumber}</PersianText></li>
              <li className='footerStyle'><PersianText>{logoImage.email}</PersianText></li>
            </ul>
          </div>
        </div>
        <hr className='m-0' />
        <div className="row">
          <div className="col text-center">
            <p className="mb-0 text-center footerStyle">© تمام حقوق برای شرکت نگین بسپار شرق محفوظ است.</p>
          </div>
        </div>
      </div>
}
    </footer>
  )
}

export default Footer
